import { render, staticRenderFns } from "./ProductNote.vue?vue&type=template&id=3777edf6&scoped=true&lang=pug"
import script from "./ProductNote.vue?vue&type=script&lang=js"
export * from "./ProductNote.vue?vue&type=script&lang=js"
import style0 from "./ProductNote.vue?vue&type=style&index=0&id=3777edf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3777edf6",
  null
  
)

export default component.exports